define('GameDayCore/GDModel/ValueObjects/HotColdZone/HotColdZone',['require','exports','module','../ValueObjectFactory','../../enums/baseball/HotColdZoneColors'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory'),
		colors  = require( '../../enums/baseball/HotColdZoneColors' );

	VO.create(HotColdZone);

	function HotColdZone($data, $isPitcher) {
		var vo = VO.ensureVO(this, HotColdZone),
			data = $data;

		vo.num = data.num || "";
		vo.ab = data.ab || "";
		vo.avg = data.avg || "";
		vo.hr = data.hr || "";
		vo.rbi = data.rbi || "";
		vo.bb = data.bb || "";
		vo.so = data.so || "";
		vo.ops = data.ops || "";
		vo.rating = data.rating || "";
		vo.sweetness = data.sweetness || "";
		vo.temperature = getHotZoneTemp(data.sweetness,$isPitcher);
		vo.color = getHotColdZoneColor(vo.temperature);
	}

	function getHotColdZoneColor (temp) {
		var lowertemp=(temp||"default").toLowerCase();
		return colors[lowertemp]||colors["default"];
    }

	function getHotZoneTemp ($sweetness, $isPitcher) {
		var temp;

		if ($sweetness >= 1.15) {
			temp = ($isPitcher) ? "Cold" : "Hot";
		} else if ($sweetness >= 1.05) {
			temp = ($isPitcher) ? "Cool" : "Warm";
		} else if ($sweetness >= 0.95) {
			temp = "Neutral";
		} else if ($sweetness >= 0.85) {
			temp = ($isPitcher) ? "Warm" : "Cool";
		} else if ($sweetness < 0.85) {
			temp = ($isPitcher) ? "Hot" : "Cold";
		} else {
			temp = "No Data";
		}

		return temp;
	}
	return HotColdZone;
});
